/**
 * Constructs the appropriate subdomain string for use with cookie domains
 * @param _window Internal parameter for Dependency Injection [DO NOT USE] -
 * window object
 * @returns {string} A string representing the subdomain for use with cookie domains
 */
export const getCookieSubdomainString = (
  /* istanbul ignore next */
  _window = window,
): string => `.${_window.location.hostname.split('.').slice(-2).join('.')}`;

export const deleteDataDogCookies = (
  /* istanbul ignore next */
  _getCookieSubdomainString = getCookieSubdomainString,
): void => {
  /**
   * Delete previous multiple `_dd_s` cookie keys set by DataDog on the OG app
   * @note TODO: Deprecate this cookie teardown once either DataDog fixes
   * this issue or we complete migration from the OG app to Core-V2
   */

  document.cookie = '_dd_s=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

  document.cookie = `_dd_s=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${_getCookieSubdomainString()};`;
};
